import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { AppointmentNumberCard } from './AppointmentNumber'

type CopyableAppointmentNumberProps = {
  number: string
  /** The hint to keep the number at hand for the check-in kiosk; it only helps before the visit. */
  showHint: boolean
  onCopy: () => void
}

/** The appointment number as the detail screen shows it: the whole card copies the number. */
const CopyableAppointmentNumber = ({ number, showHint, onCopy }: CopyableAppointmentNumberProps) => {
  const theme = useTheme()

  return (
    <AppointmentNumberCard onClick={onCopy}>
      <AppointmentNumberCard.Label>
        {t({
          id: 'appointments.detail.appointment-number.label',
          message: 'Afspraaknummer',
        })}
      </AppointmentNumberCard.Label>
      <Flex alignItems='center' gap={theme.UI.Spacing.Space2}>
        <AppointmentNumberCard.Value>{number}</AppointmentNumberCard.Value>
        <AppointmentNumberCard.Icon
          icon={['far', 'copy']}
          title={t({
            id: 'appointments.detail.appointment-number.copy',
            message: 'Afspraaknummer kopiëren',
          })}
        />
      </Flex>
      {showHint ? (
        <AppointmentNumberCard.Hint>
          {t({
            id: 'appointments.detail.appointment-number.hint',
            message: 'Houd dit nummer bij de hand aan de aanmeldkiosk.',
          })}
        </AppointmentNumberCard.Hint>
      ) : null}
    </AppointmentNumberCard>
  )
}

export { CopyableAppointmentNumber }
